"use client";

import { useEffect } from "react";

import { getCurrentSessionContext } from "@/app/actions";
import { getHttpClientConfig } from "@/config/http-client";
import { initializeStoreFromContext } from "@/app/store";

/**
 * A first-time visitor is served without a session, so the page is never held
 * up creating one. That makes the browser responsible for starting the session
 * once the page is on screen.
 */
export function UserManager(): null {
	useEffect(() => {
		const initialize = async (): Promise<void> => {
			let context = await getCurrentSessionContext();

			if (!context) {
				await fetch("/api/session", {
					method: "POST",
					signal: AbortSignal.timeout(
						getHttpClientConfig().timeoutSeconds * 1000
					)
				});
				context = await getCurrentSessionContext();
			}

			if (context) {
				initializeStoreFromContext(context);
			}
		};

		initialize();
	}, []);

	return null;
}
